import { useEffect, useState } from "react";
import api from "../../../../configs/api";
import { useParams } from "react-router-dom";
import AdminResidentialPropertyDetails from "./AdminResidentialPropertyDetails";
import AdminCommercialPropertyDetails from "./AdminCommercialPropertyDetails";
import AdminLandPropertyDetails from "./AdminLandPropertyDetails";
import AdminProjectPropertyDetails from "./AdminProjectPropertyDetails";
import Loader from "../../../../components/Loader";

const AdminPropertyDetailsPage = () => {
  const { id } = useParams();
  const [property, setProperty] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (id) {
      fetchPropertyDetail(id);
    }
  }, [id]);

  const fetchPropertyDetail = async (propertyId) => {
    try {
      const res = await api.get(`/properties/${propertyId}`);
      setProperty(res.data.data);
      // console.log("res:", res);
    } catch (error) {
      console.error("Error fetching property:", error);
    } finally {
      setLoading(false);
    }
  };

  const renderDetailComponent = () => {
    if (!property) return null;

    switch (property.type) {
      case "residential":
        return <AdminResidentialPropertyDetails property={property} />;
      case "commercial":
        return <AdminCommercialPropertyDetails property={property} />;
      case "land":
        return <AdminLandPropertyDetails property={property} />;
      case "project":
      return <AdminProjectPropertyDetails property={property} />;
      default:
        return <div>Property type not supported</div>;
    }
  };

  if (loading) return <Loader />;
  if (!property) return <div>Property not found</div>;

  return <div className="property-detail">{renderDetailComponent()}</div>;
};

export default AdminPropertyDetailsPage;
